import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import AccountSetupDatatableHandler from '../../containers/datatableHandlers/AccountSetupDatatableHandler/AccountSetupDatatableHandler';
import BankUpdateAddressFormHandle from '../../containers/formHandlers/bank/BankUpdateAddressFormHandler/BankUpdateAddressFormHandle';
import Update1FormHandle from '../../containers/formHandlers/bank/Update1FormUI/Update1FormHandle';

const tabHeaders = ['Banque', 'Adresse', 'Compte réglement'];
const tabContents = [
  <Update1FormHandle />,
  <BankUpdateAddressFormHandle />,
  <AccountSetupDatatableHandler />,
];

export default function Update() {
  return (
    <>
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} />
    </>
  );
}
